import PluginInterface, { PluginName } from "@/plugins/core/interface";
import CommManagerInterface from "@/hosted_fields/master/interface";

export default class PluginFactory {
  public static create(plugin: PluginName, commMgr: CommManagerInterface): Promise<PluginInterface> {
    switch(plugin) {

      case PluginName.COMPONENTS_FIELDS: {
        return import('@/plugins/components_fields/actions').then(module => {
          const ComponentsAndFieldsPlugin = module.default;
          return new ComponentsAndFieldsPlugin(commMgr)
        })
      }
      
      case PluginName.LOGGER: {
        return import('@/plugins/logger/actions').then(module => {
          const LoggerPlugin = module.default;
          const logger = new LoggerPlugin(commMgr);
          logger.setMetadata(commMgr.getSiteInfo())
          return logger;
        })
      }
      
      case PluginName.THREE_DOMAIN_SECURE: {
        return import('@/plugins/three_domain_secure/actions').then(module => {
          const ThreeDomainSecurePlugin = module.default;
          return new ThreeDomainSecurePlugin(commMgr)
        })
      }

      case PluginName.CHECKOUT_UTILS: {
        return import('@/plugins/checkout_utils/actions').then(module => {
          const CheckoutUtilsPlugin = module.default;
          return new CheckoutUtilsPlugin(commMgr)
        })
      }

      case PluginName.FUNCTIONS: {
        return import('@/plugins/functions/actions').then(module => {
          const FunctionsPlugin = module.default;
          return new FunctionsPlugin(commMgr)
        })
      }

      case PluginName.IDEAL: {
        return import('@/plugins/payments/iDeal/actions').then(module => {
          const IDealPlugin = module.default;
          return new IDealPlugin(commMgr)
        })
      }

      case PluginName.SOFORT: {
        return import('@/plugins/payments/sofort/actions').then(module => {
          const SofortPlugin = module.default;
          return new SofortPlugin(commMgr)
        })
      }

      case PluginName.BANCONTACT: {
        return import('@/plugins/payments/bancontact/actions').then(module => {
          const BancontactPlugin = module.default;
          return new BancontactPlugin(commMgr)
        })
      }

      case PluginName.GOOGLE_PAY: {
        return import('@/plugins/payments/google_pay/actions').then(module => {
          const GooglePayPlugin = module.default;
          return new GooglePayPlugin(commMgr)
        })
      }

      case PluginName.GIROPAY: {
        return import('@/plugins/payments/giropay/actions').then(module => {
          const GiropayPlugin = module.default;
          return new GiropayPlugin(commMgr)
        })
      }

      case PluginName.DOTPAY: {
        return import('@/plugins/payments/dotpay/actions').then(module => {
          const DotpayPlugin = module.default;
          return new DotpayPlugin(commMgr)
        })
      }
      case PluginName.PAYPAL: {
        return import('@/plugins/payments/paypal_express_checkout/actions').then(module => {
          const PaypalPlugin = module.default;
          return new PaypalPlugin(commMgr)
        })
      }
      case PluginName.NETBANKING: {
        return import('@/plugins/payments/netbanking_emandates/actions').then(module => {
          const NetbankingPlugin = module.default;
          return new NetbankingPlugin(commMgr)
        })
      }
      case PluginName.DIRECT_DEBIT: {
        return import('@/plugins/payments/direct_debit/actions').then(module => {
          const DirectDebitPlugin = module.default;
          return new DirectDebitPlugin(commMgr)
        })
      }
      case PluginName.APPLE_PAY: {
        return import('@/plugins/payments/apple_pay/actions').then(module => {
          const ApplePayPlugin = module.default;
          return new ApplePayPlugin(commMgr)
        })
      }
    }
  }
}